import { render } from "./ChotGPT.vue?vue&type=template&id=dc6dab60"
import script from "./ChotGPT.vue?vue&type=script&lang=js"
export * from "./ChotGPT.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__